import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ChiSiamoPage = lazy(() => import('../pages/chi-siamo/page'));
const ProdottiPage = lazy(() => import('../pages/prodotti/page'));
const ServiziPage = lazy(() => import('../pages/servizi/page'));
const ContattiPage = lazy(() => import('../pages/contatti/page'));
const InfoLegaliPage = lazy(() => import('../pages/info-legali/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/chi-siamo',
    element: <ChiSiamoPage />,
  },
  {
    path: '/prodotti',
    element: <ProdottiPage />,
  },
  {
    path: '/servizi',
    element: <ServiziPage />,
  },
  {
    path: '/contatti',
    element: <ContattiPage />,
  },
  {
    path: '/info-legali',
    element: <InfoLegaliPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
